import React from 'react';
import '../../style/carousel-modal/carousel-root.css';
const CarouselStyles = () => <></>;
export default CarouselStyles;